interface Props {
  stamps: number;
  redemptions: number;
  compsSent: number;
  compsRedeemed: number;
  estRevenue: number;
  compReturnRate: number | null;
}

function Stat({ label, value }: { label: string; value: string | number }) {
  return (
    <div>
      <div className="font-grotesk font-bold text-[26px] leading-none text-primary mb-[7px]">{value}</div>
      <div className="font-heading text-[8px] text-body-grey tracking-wide">{label}</div>
    </div>
  );
}

export default function RoiStrip({ stamps, redemptions, compsSent, compsRedeemed, estRevenue, compReturnRate }: Props) {
  const fmt = new Intl.NumberFormat();
  const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
  return (
    <div className="bg-white rounded-[10px] p-[18px] grid grid-cols-2 sm:grid-cols-3 gap-x-3 gap-y-[18px]">
      <Stat label="STAMPS" value={fmt.format(stamps)} />
      <Stat label="REDEEMED" value={fmt.format(redemptions)} />
      <Stat label="COMPS SENT" value={fmt.format(compsSent)} />
      <Stat label="COMPS USED" value={fmt.format(compsRedeemed)} />
      <Stat label="BACK ≤14D OF COMP" value={compReturnRate === null ? '—' : `${Math.round(compReturnRate * 100)}%`} />
      <Stat label="EST REVENUE" value={money.format(estRevenue)} />
    </div>
  );
}
